import { render, staticRenderFns } from "./areaDetail.vue?vue&type=template&id=bca1f7b6&scoped=true"
import script from "./areaDetail.vue?vue&type=script&lang=js"
export * from "./areaDetail.vue?vue&type=script&lang=js"
import style0 from "./areaDetail.vue?vue&type=style&index=0&id=bca1f7b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca1f7b6",
  null
  
)

export default component.exports